import type { ToastType } from '~/components/Global/Interactions/Toast/Toast'
import { getToaster } from '~/components/Global/Interactions/Toast/getToaster'

export const toast = (
  title?: string,
  content?: string,
  type?: ToastType
): boolean => getToaster().current(title, content, type)
